//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.unidadeAdm || !state.unidadeAdm.data) return null;
    return Moment(String(state.unidadeAdm.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.unidadesAdm.length;
}

export default {
    dataFormatada,
	getCount
}